import { IProduct } from '@kizi/comparator-core';
import { Div, DivProps, P, Span } from '@kizi/core-components';
import React from 'react';
import { formatPrice } from '../../utils/global';

const blockStyles = {
  paddingBottom: 1,
  borderBottom: '1px solid',
  borderColor: 'second.1',
  '& h3': { fontSize: 2 },
  '& p': { fontSize: 1 },
  '& > div': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};
export interface LayoverCostOverviewProps extends DivProps {
  data?: IProduct;
}

export const LayoverCostOverview: React.FC<LayoverCostOverviewProps> = ({
  data,
  ...restProps
}) => {
  if (!data) {
    return null;
  }
  const { name } = data.provider;
  const {
    connection = 0,
    postage = 0,
    total = 0,
    priceList = [],
    installation,
  } = data.priceInfo;

  const discount = data.priceInfo.discountIncluded;
  const cbDiscount = data.priceInfo.providerDiscount || 0;

  const cashbackInfo = {
    title: discount
      ? discount > cbDiscount
        ? `Cashback`
        : 'Cashback Consumentenbond'
      : 'Eenmalige korting via ons',
    value: discount,
  };

  const discountInfo = {
    title: priceList.length
      ? `Korting eerste ${Math.min(data.priceInfo.priceList[0]?.periodInMonth || 0, 12)} maanden`
      : '',
    value: priceList.length
      ? (data.priceInfo.total - data.priceInfo.priceList[0]?.amount) *
        Math.min(data.priceInfo.priceList[0]?.periodInMonth || 0, 12)
      : 0,
  };

  const installationCost = installation?.filter((cost) => cost.required);

  const totalinstallationCost = installationCost?.reduce(
    (acc, curr) => acc + curr.rate,
    0,
  );

  return (
    <Div variant="pricePopupContainer" {...restProps}>
      <Div css={blockStyles}>
        <h3>Maandelijkse kosten</h3>
        <Div>
          <P>{name}</P>
          <Span>{formatPrice(total)}</Span>
        </Div>
      </Div>

      <Div css={blockStyles}>
        <h3>Eenmalige kosten</h3>

        {installationCost.map(({ name, rate }) => {
          return (
            <Div key={name}>
              <P>{name}</P>
              <Span>{formatPrice(rate)}</Span>
            </Div>
          );
        })}

        <Div>
          <P>Eenmalige aansluitkosten</P>
          <Span>{formatPrice(connection)}</Span>
        </Div>

        <Div>
          <P>Verzend- en administratiekosten</P>
          <Span>{formatPrice(postage)}</Span>
        </Div>
      </Div>

      <Div css={blockStyles}>
        <h3>Kortingen</h3>
        <Div>
          <P>{discountInfo.title}</P>
          <Span>{`- ${formatPrice(discountInfo.value)}`}</Span>
        </Div>
        <Div>
          <P>{cashbackInfo.title}</P>
          <Span>{`- ${formatPrice(cashbackInfo.value)}`}</Span>
        </Div>
      </Div>
      <Div
        css={{
          ...blockStyles,
          borderBottom: '2px solid',
          borderColor: 'second.0',
        }}
      >
        <h3>Totaal</h3>
        <Div>
          <P>Totale maandelijkse kosten</P>
          <Span>{formatPrice(total * 12)}</Span>
        </Div>
        <Div>
          <P>Totale eenmalige kosten</P>
          <Span>
            {formatPrice(postage + connection + totalinstallationCost)}
          </Span>
        </Div>
        <Div>
          <P>Totale korting</P>
          <Span>{`- ${formatPrice(
            discountInfo.value + cashbackInfo.value,
          )}`}</Span>
        </Div>
      </Div>
      <Div css={{ ...blockStyles, borderBottom: 'none' }}>
        <Div>
          <h3>Totale kosten eerste jaar</h3>
          <Span>
            {formatPrice(
              total * 12 -
                discountInfo.value -
                cashbackInfo.value +
                connection +
                postage +
                totalinstallationCost,
            )}
          </Span>
        </Div>
      </Div>
    </Div>
  );
};
